/**
 * TanStack Query configuration.
 *
 * Re-exported for convenience — the QueryClient is created in main.tsx.
 */

export const STALE_TIME = 0; // Always refetch to avoid stale-data bugs
export const RETRY = false;
export const REFRESH_ON_WINDOW_FOCUS = false;
